import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import logoWhite from '../assets/images/logo-white.png';
import {Link} from "react-router-dom";
import {loginSuccess} from "../state/actions/auth";
import {connect} from 'react-redux';
import {fetchBusiness} from "../state/actions/business";


export class ProHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    const {classes} = this.props;

    const collapsed = this.state.collapsed;
    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
      <nav className={`${classes.navBar} navbar navbar-dark navbar-expand-lg`}>
        <Link className="navbar-brand" to={config.routes.home}>
          <img className={classes.navLogo} src={logoWhite}/>
        </Link>
        <button onClick={this.toggleNavbar} className={`${classTwo}`} type="button"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className={`${classes.navBarTogglerIcon} navbar-toggler-icon`}/>
        </button>
        <div className={`${classOne} justify-content-end`} id="navbarSupportedContent">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.pros}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.prosFaq}>FAQ</Link>
            </li>
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.prosSignUp}>Sign Up</Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}


const styles = (theme) => ({
  navBar: {
    padding: '15px 0 30px',
    [theme.breakpoints.up('md')]: {
      padding: '15px 0 0',
    }
  },
  navLogo: {
    height: '40px',
  },
  navLink: {
    color: '#ffffff !important',
  },
});

export default (withStyles(styles)(ProHeader));



// WEBPACK FOOTER //
// ./src/parts/ProHeader.js